const SAFE_DEPOSITS_LIST_URL = "/v1/bank/safe-deposits-list";
const BANK_LIST_URL = "/v1/bank/list";

const BANK_ACCOUNT_LIST_URL = "/v1/bank/account-list";
const BANK_ACCOUNT_ADD_URL = "/v1/bank/account-add";
const BANK_ACCOUNT_UPDATE_URL = "/v1/bank/account-update";
const BANK_ACCOUNT_DELETE_URL = "/v1/bank/account-delete";
const BANK_ACCOUNT_SINGLE_URL = "/v1/bank/account-delete";

const BANK_INSTALLMENT_LIST_URL = "/v1/bank/installment-list";
const BANK_INSTALLMENT_ADD_URL = "/v1/bank/installment-add";
const BANK_INSTALLMENT_UPDATE_URL = "/v1/bank/installment-update";
const BANK_INSTALLMENT_DELETE_URL = "/v1/bank/installment-delete";
const BANK_INSTALLMENT_SINGLE_URL = "/v1/bank/installment-single";

const BANK_PARAMETER_LIST_URL = "/v1/bank/parameter-list";
const BANK_PARAMETER_ADD_URL = "/v1/bank/parameter-add";
const BANK_PARAMETER_UPDATE_URL = "/v1/bank/parameter-update";
const BANK_PARAMETER_DELETE_URL = "/v1/bank/parameter-delete";
const BANK_PARAMETER_SINGLE_URL = "/v1/bank/parameter-single";


const BANK_API_URL_LIST = {
    SAFE_DEPOSITS_LIST_URL,
    BANK_LIST_URL,
    BANK_ACCOUNT_LIST_URL,
    BANK_ACCOUNT_SINGLE_URL,
    BANK_ACCOUNT_ADD_URL,
    BANK_ACCOUNT_UPDATE_URL,
    BANK_ACCOUNT_DELETE_URL,

    BANK_INSTALLMENT_LIST_URL,
    BANK_INSTALLMENT_ADD_URL,
    BANK_INSTALLMENT_UPDATE_URL,
    BANK_INSTALLMENT_DELETE_URL,
    BANK_INSTALLMENT_SINGLE_URL,

    BANK_PARAMETER_LIST_URL,
    BANK_PARAMETER_ADD_URL,
    BANK_PARAMETER_UPDATE_URL,
    BANK_PARAMETER_DELETE_URL,
    BANK_PARAMETER_SINGLE_URL,

}

export { BANK_API_URL_LIST };